import {Injectable} from '@angular/core'
import {Order} from '@models/order/order'
import {OrderProduct} from '@models/order/orderproduct'
import {CatalogOnlineService} from './catalog-online.service'
import type {RoundDecimalsConf} from '@models/configAgent'

/**
 * Variante embebida del catálogo online.
 *
 * @description
 * Marca `fromEmbedded = true` para que la construcción del template tome en cuenta el
 * contexto embebido (por ejemplo, no recalcular totales que el host ya ha totalizado).
 * Sobrescribe `calculateTotalLine` como identidad porque el cálculo de línea se hace en
 * el host antes de enviarlo.
 */
@Injectable({
  providedIn: 'root',
})
export class CatalogOnlineEmbeddedService extends CatalogOnlineService {
  override getOrderTemplate = async (
    outletId: string,
    allOrders: Order[],
    onlyIdsAndQuantites: boolean,
    useExtension: boolean
  ): Promise<OrderProduct[]> => {
    this.fromEmbedded = true
    return this.getOrderTemplateMain(outletId, allOrders, onlyIdsAndQuantites, useExtension)
  }

  override calculateTotalLine = (product: OrderProduct, roundConf: RoundDecimalsConf): OrderProduct => product
}
